import { cloneDeep } from 'lodash';

const sanitiseValue = (s: any) => {
  if (typeof s === 'string') {
    // eslint-disable-next-line no-useless-escape
    return s.replace(/[`~!@#$%^&*()|+=?;:'",.<>\{\}\[\]\\\/]/gi, '');
  }
  return s;
};

const sanitiseXSS = (params: any) => {
  if (params === null) {
    return params;
  }

  if (typeof params !== 'object') {
    return sanitiseValue(params);
  }

  const result = cloneDeep(params);
  Object.keys(result).forEach((key) => {
    result[key] = sanitiseValue(result[key]);
  });
  return result;
};

export default sanitiseXSS;
